import { render, staticRenderFns } from "./SearchConsole.vue?vue&type=template&id=20d5b317&scoped=true"
import script from "./SearchConsole.vue?vue&type=script&lang=js"
export * from "./SearchConsole.vue?vue&type=script&lang=js"
import style0 from "./SearchConsole.vue?vue&type=style&index=0&id=20d5b317&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d5b317",
  null
  
)

export default component.exports